module.exports = __webpack_public_path__ + "32e7ae426989dc74b2c9d1241a76eed7.ttf";